import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

import { BaseRendererComponent } from '../base-renderer/base-renderer.component';

@Component({
  selector: 'app-image-renderer',
  templateUrl: './image-renderer.component.html',
  styleUrl: './image-renderer.component.scss',
})
export class ImageRendererComponent extends BaseRendererComponent implements ICellRendererAngularComp {}
